import { action } from "satcheljs";

const resetTimeOffReasonsStore = action(
    "resetTimeOffReasonsStore", () => ({})
);

export default resetTimeOffReasonsStore;
